import ReactOnRails from 'react-on-rails';

import GuestSignUp from '../bundles/GuestSignUp/startup/registration';

ReactOnRails.register({
  GuestSignUp,
});
